import classNames from 'classnames';
import React, { useMemo } from 'react';
import TextAlign from '../../types/enum/TextAlign';
import './TableCell.scss';
import ITableCellProps from './TableCellProps';

const TableCell = ({ onClick, size, style, priority, align, disabled, className, children }: ITableCellProps) => {
  const classes = classNames(
    {
      'table-cell': true,
      'table-cell-clickable': onClick,
      [`align-${align}`]: true,
      [`table-col-priority-${priority}`]: priority,
    },
    className
  );

  function handleClick(event: React.MouseEvent<HTMLTableDataCellElement>) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }

  const combinedStyle = useMemo(() => ({ ...style, width: size }), [size, style]);

  return (
    <td className={classes} onClick={handleClick} style={combinedStyle}>
      {children}
    </td>
  );
};

TableCell.defaultProps = {
  align: TextAlign.LEFT,
  disabled: false,
};

export default React.memo(TableCell);
